/**
 * The shape of a printed short code.
 *
 * Six characters from a thirty symbol alphabet: 729 million codes, and none of
 * them can be misread aloud. 0 and O are gone, so are 1, I and L, and so is U,
 * which people hear as V.
 *
 * Lives here rather than in App.js so the deep link router and anything else
 * that has to recognise one can share a single definition, and so it can be
 * tested without mounting the app.
 */

/**
 * Exactly six, from the unambiguous alphabet. Case insensitive on the way in.
 *
 * The ranges have to match `cc_new_short_code` in the database exactly:
 * 23456789ABCDEFGHJKMNPQRSTVWXYZ. J-N was wrong - it lets L through, and L is
 * one of the four letters the alphabet drops precisely because it is misread.
 */
export const SHORT_CODE_RE = /^[2-9A-HJ-KM-NP-TV-Z]{6}$/i;

export function isShortCode(value) {
  return SHORT_CODE_RE.test(String(value ?? '').trim());
}

/**
 * A printed label's URL, turned into the route it stands for.
 *
 * The label carries cardchase.org/TS2SWJ because a QR on a 12mm strip has room
 * for 21 modules and 21 modules hold 20 characters. On the web that path is a
 * redirect; on a phone with the app installed the universal link arrives here
 * instead and never touches the network.
 *
 * @returns {string|null} an in-app route, or null when this is not one of ours.
 */
export function routeForShortLink(url) {
  const m = String(url ?? '').match(/^https?:\/\/(?:www\.)?cardchase\.org\/([^/?#]+)\/?$/i);
  if (!m || !isShortCode(m[1])) return null;
  return `/c/${m[1].toUpperCase()}`;
}
